import {fromJson} from "../utils/helper.js";


class GDocument {


    constructor() {

        this.id = null;
        this.documentable_id = null
        this.documentable_type = null
        this.type = null
        this.description = null
        this.path = null

    }


    static fromJson(object) {
        return fromJson((new GDocument()), object);
    }

}

export default GDocument;
